import { useEffect, useState } from 'react';
import VideoPreviewModal from '../Tutorials/VideoPreviewModal';
import { fetchAllPages } from '../../helpers/apiHelper';
import { apiUpdateUserDetails, getTutorialVideo } from '../../helpers/api';
import { TUTORIAL } from '../../constants/constants';
import { requestsSelector, setPlayRequestVideo } from '../../redux/slicers/requestSlicer';
import { useSelector } from 'react-redux';
import { dispatcher } from '../../helpers/projectHelper';
import { useUserContext } from '../../contexts/UserContext';
import { navigateToNewRequest, objectToFormData, setLocalStorage } from '../../helpers/jsHelper';
import { ADMIN_DASHBOARD, REQUESTS_ROUTE } from '../../config/constant/routePathConstant';
import { NEW_REQUEST_ROUTE } from '../../constants/routePathConstants';
import { useInfoDialogaActions } from '../../hooks/useInfoDialogaActions';
import { useSearchParams } from 'react-router-dom';

export const RequestTutorialVideo = () => {
  const { currentUser, updateUserData } = useUserContext();
  const [previewVideoDetails, setPreviewVideoDetails] = useState(null);
  const requestSelector = useSelector(requestsSelector);

  const isRequestPage = window.location.pathname === REQUESTS_ROUTE;
  const play = requestSelector?.playRequestVideo; // || (!currentUser?.user?.other_info?.isRequestVideoPlayed && isRequestPage); // preventing the request video play when user first time comes on the request page

  const playVideo = async () => {
    if (
      !requestSelector?.playRequestVideo ||
      !currentUser?.user?.other_info?.isRequestVideoPlayed
    ) {
      const userDetails = await updateUserData();
      if (userDetails?.user?.other_info?.isRequestVideoPlayed) return;
    }

    const params = 'is_active=true';
    const results = await fetchAllPages(
      async (page) => await getTutorialVideo(params + `&page=${page}`)
    );
    if (results) {
      const requestVideo = results?.results
        ?.filter((a) => a.category_type === TUTORIAL)
        ?.find((a) => a.name?.toLowerCase() === 'request module');

      if (requestVideo) setPreviewVideoDetails(requestVideo);
    }
  };

  const onClose = async () => {
    dispatcher(setPlayRequestVideo(false));
    setPreviewVideoDetails(null);

    if (!currentUser?.user?.other_info?.isRequestVideoPlayed) {
      const payload = {
        other_info: JSON.stringify({
          ...(currentUser?.user?.other_info || {}),
          isRequestVideoPlayed: true,
        }),
      };
      const formData = objectToFormData(payload);
      await apiUpdateUserDetails(formData);
      updateUserData();
    }
  };

  useEffect(() => {
    if (!play) return;
    playVideo();

    return () => onClose();
  }, [play]);

  if (!previewVideoDetails || !play) return null;

  return <VideoPreviewModal data={previewVideoDetails} setPreviewVideoDetails={onClose} />;
};

export const RequestPackWelcomeModal = () => {
  const { currentUser, isPackOrganization, isPremiumUser } = useUserContext();
  const { openInfoDialog, closeInfoDialog } = useInfoDialogaActions();
  const [searchParams, setSearchParams] = useSearchParams();

  const welcomePack = searchParams.get('welcome') === 'true';
  const purchaseId = searchParams.get('purchase_id');
  const seq = searchParams.get('seq');
  const isExistingModel = searchParams.get('is_existing_model');

  const isDashboardPage =
    window.location.pathname === '/' || window.location.pathname.includes(ADMIN_DASHBOARD);

  const onClose = () => {
    navigateToNewRequest({
      purchase_id: purchaseId,
      seq: seq,
      is_existing_model: isExistingModel,
    });
    closeInfoDialog();
    setSearchParams({});
  };

  useEffect(() => {
    if (
      !currentUser ||
      !isDashboardPage ||
      !welcomePack ||
      !(isPackOrganization || isPremiumUser())
    )
      return;
    openInfoDialog({
      title: 'Welcome to imagine.io!',
      description: 'Ready to start your journey?',
      buttonText: 'Submit your request now!',
      onButtonClick: onClose,
      closeable: false,
      preventClose: true,
    });
  }, [currentUser, isDashboardPage, welcomePack, isPackOrganization, isPremiumUser]);

  return null;
};